import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import Classnames from 'classnames';
import Select from 'react-select';
import { Pagination , Modal } from 'react-bootstrap';
import { MonthView , TransitionView } from 'react-date-picker';
import moment from 'moment';
import {parseAddress} from 'utils';
import { ClientsDownload } from 'components';

import 'react-select/dist/react-select.css';

class ClientsFilters extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'ClientsFilters';
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      filtersVisible : true,
      show_storm_date_picker : false,
      show_name : false
    }
    this.toggleFilters = this.toggleFilters.bind(this);
    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.dateTimer = null;
  }
  handleChange(type, value) {
    this.props.setClientsFilters({ filters : value });
    return this.props.onFilter({ filters : value });
  }
  handleAddFilter(name) {
    switch(name) {
      case 'calendar':
        return this.setState({show_storm_date_picker : true});
      case 'name':
        return this.setState({show_name : true});
    }
  }
  componentWillMount() {
    this.props.fetchClientsFilters();
  }
  componentDidMount() {
  	let width = $('body').prop('clientWidth')
  	if (width < 500) {
  		this.setState({filtersVisible : false})
  	}
  }
  toggleFilters() {
    this.setState({filtersVisible : !this.state.filtersVisible},
    	this.props.toggleShowFilters(this.state.filtersVisible));
  }
  render() {
    const { filters , selected_filters, fetching_filters, fetching_clients, current_place } = this.props;
    const filtersClass = Classnames({
      "client-filter" : true,
      "closed" : !this.state.filtersVisible
    })

    if(!filters) {
      return <div></div>
    }

    return (
      <div className={filtersClass + ' hidden-print'}>
      	<div className='clients-filters-container'>
	        <div className="content clearfix pt-sm pb-sm">
	          <div className="col-xs-6 col-sm-2 add-client-button">
              {fetching_filters || fetching_clients ? <div className="btn btn-block"><i className="fa fa-spinner fa-spin"></i> Loading</div> :
	            <div
                onClick={() => {this.props.startCreatingClient({address : current_place ? parseAddress(current_place) : {}})}}
                className="btn btn-block btn-primary"
                >
                <i className="fa fa-plus"></i> Client
              </div>}
	          </div>
	          <div className="col-xs-6 col-sm-2 select-columns-button">
              <div onClick={this.props.showSelectingClientColumns} className="btn btn-block btn-default"><i className="fa fa-columns"></i> Select Columns</div>
	          </div>
	          <div className="col-xs-12 col-sm-3 pb-xs">
	            <Select
	              multi={true}
	              options={filters ? filters.filter(({value}) => (value)).map(filter => {
	                switch(filter.type) {
	                  default:
	                    return {
	                      value: filter.value,
	                      type : filter.type,
	                      label: `${filter.type}: ${filter.label || filter.value}`
	                    }
	                }
	              }) : []}
	              placeholder="Type to select filters, or add filters."
	              value={selected_filters}
	              simpleValue={false}
	              onChange={value => this.handleChange('filters', value)}
	            />
	          </div>
            <div className="col-xs-12 col-sm-2">
              <ClientsDownload />
            </div>
	          <div className="col-xs-12 col-sm-3">
	            <div className="btn-group">
	              <div onClick={e => this.handleAddFilter('calendar')} className="btn btn-default clients-filter-buttons"><i className="fa fa-calendar"></i> Impact Date Filter</div>
	              <div onClick={e => this.handleAddFilter('name')} className="btn btn-default clients-filter-buttons"><i className="fa fa-font"></i> Name Filter</div>
	            </div>
	          </div>
	        </div>
	        <div onClick={this.toggleFilters} className="toggler visible-xs">
	          {(()=>{
	            if(this.state.filtersVisible)
	              return 'Hide Filters';

	            return 'Show Filters';
	          })()}
	        </div>
        </div>
        <Modal show={this.state.show_storm_date_picker} onHide={f => this.setState({ show_storm_date_picker : false })}>
          <Modal.Header>
            <h3 className="text-center">Filter Clients By Maps</h3>
            <p>Select a date range below to filter your clients by.</p>
            <p>The system will return all the clients impacted in that date range.</p>
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-info">This feature is in Beta, so it may take longer to load. If things take too long, try a smaller date range.</div>
            <TransitionView
              footer={false}
              navigation={true}
            >
              <MonthView
                highlightWeekends={true}
                highlightToday={true}
                weekNumbers={true}
                locale="en"
                highlightRangeOnMouseMove={true}
                weekStartDay={0}
                footer={false}
                onRangeChange={(date) => {
                  if(this.dateTimer) {
                    clearTimeout(this.dateTimer);
                  }

                  this.dateTimer = setTimeout(() => {
                    this.props.addClientsFilter({
                      value : date,
                      type : 'storm_date',
                      label : `storm date: ${moment(date[0]).format('MM/DD/YY')} - ${moment(date[1]).format('MM/DD/YY')}`
                    });
                    this.setState({show_storm_date_picker : false});
                    this.props.fetchClients();
                  }, 100);
                }}
                defaultRange={[]}
              />
            </TransitionView>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-xs-12 col-md-4 col-md-offset-8">
                <div onClick={f => this.setState({show_storm_date_picker : false})} className="btn btn-block btn-default">Close</div>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.show_name} onHide={f => this.setState({ show_name : false })}>
          <div className="row">
            <div className="col-xs-12">
              <div className="input-group">
                <label className="input-group-addon">Name </label>
                <input className="form-control" onChange={event => {
                  let value = event.target.value;
                  this.setState({name : value});
                }} value={this.state.name} />

                <div className="input-group-btn">
                  <div onClick={e => {
                    if(this.state.name) {
                      this.props.addClientsFilter({
                        value : this.state.name,
                        type : 'name',
                        label : `name: ${this.state.name}`
                      });
                      this.props.fetchClients();
                    }
                    this.setState({name : '', show_name : false});
                  }} className="btn btn-primary"><i className="fa fa-plus"></i></div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

ClientsFilters.propTypes = {
  onFilter : PropTypes.func,
}
ClientsFilters.contextTypes = {
  router : PropTypes.object,
}
const mapStateToProps = ({clients : { array, filters, selected_filters, fetching_filters, fetching_clients, total, offset, size, current_place}}) => ({
  array,
  filters,
  selected_filters,
  fetching_filters,
  fetching_clients,
  total,
  offset,
  size,
  current_place
})

export default connect(mapStateToProps, Actions)(ClientsFilters);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-filters.js